<template>
  <div v-if="searchInit">
    <!-- 搜索栏 -->
    <van-sticky>
      <div class="search-wrapper">
        <div class="search-bar">
          <div class="publisher-select" @click="showTeacher()">
            <span v-if="teacherid == ''">{{ $t("notice.publisher") }}</span>
            <van-image v-else-if="teacherphotoUrl" round :src="teacherphotoUrl" class="avatar-select mr-5" />
            <van-icon name="arrow-down" class="ml-5" v-if="!showAllTeacher" />
            <van-icon name="arrow-up" class="ml-5" v-else />
          </div>
          <van-search
            v-model="search"
            shape="round"
            :placeholder="$t('notice.search_notice')"
            clearable
            clear-trigger="always"
            @clear="clearSearch"
            class="flex1"
            @search="onSearch"
            @click-input="
              showAllTeacher = false;
              showSettings = false;
            "
          />
          <van-icon name="setting-o" class="ml-10 font16 color3" @click="settings()" />
        </div>
        <!-- 发布人下拉面板 -->
        <div class="teacher-dropdown" v-show="showAllTeacher">
          <van-search
            v-if="teacherList.length>10"
            v-model="teacherSearch"
            shape="round"
            :placeholder="$t('notice.Search_teacher_name')"
            clearable
            clear-trigger="always"
          />
          <div class="teacher-list" ref="teacherList" :style="{ maxHeight: teacherListHeight ? teacherListHeight + 'px' : '' }">
            <div class="text-center p16 color9 font14" v-if="filteredTeacherList.length === 0">{{ $t("global.empty") }}</div>
            <div class="teacher-item" :class="{ teacherActive: item.uid == teacherid }" v-for="(item, index) in filteredTeacherList" :key="index" @click="selectTeacher(item)">
              <van-image round :src="item.photoUrl" class="teacher-avatar" />
              <div class="teacher-info">
                <div class="teacher-name">{{ item.name }}</div>
                <div class="teacher-position">{{ item.hrPosition }}</div>
              </div>
              <van-icon name="success" color="#1989FF" v-if="item.uid == teacherid" size="20" />
            </div>
          </div>
        </div>
        <!-- 设置面板 -->
        <div class="settings-panel" v-show="showSettings">
          <div class="settings-section">
            <div class="settings-label">{{ $t("notice.search_include") }}</div>
            <div class="settings-options">
              <div class="option-btn" :class="{ active: pendingSettings.includesNotice }" @click="toggleType('includesNotice')">{{ $t("notice.notice") }}</div>
              <div class="option-btn" :class="{ active: pendingSettings.includesJournal }" @click="toggleType('includesJournal')">{{ $t("notice.direct_message") }}</div>
              <div class="option-btn" :class="{ active: pendingSettings.includesComment }" @click="toggleType('includesComment')">{{ $t("notice.Comments") }}</div>
            </div>
          </div>
          <div class="settings-section">
            <div class="settings-label">{{ $t("notice.low_relevance") }}</div>
            <div class="settings-options">
              <div class="option-btn" :class="{ active: pendingSettings.showLowRelevance }" @click="pendingSettings.showLowRelevance = true">{{ $t("notice.Display") }}</div>
              <div class="option-btn" :class="{ active: !pendingSettings.showLowRelevance }" @click="pendingSettings.showLowRelevance = false">{{ $t("notice.Hide") }}</div>
              <div class="option-null"></div>
            </div>
          </div>
          <div class="settings-section">
            <div class="settings-label">{{ $t("notice.score_label") }}</div>
            <div class="settings-options">
              <div class="option-btn" :class="{ active: pendingSettings.showScore }" @click="pendingSettings.showScore = true">{{ $t("notice.Display") }}</div>
              <div class="option-btn" :class="{ active: !pendingSettings.showScore }" @click="pendingSettings.showScore = false">{{ $t("notice.Hide") }}</div>
              <div class="option-null"></div>
            </div>
          </div>
          <div class="settings-actions">
            <div class="btn-reset" @click="resetSettings">{{ $t("global.Reset") }}</div>
            <div class="btn-confirm" @click="confirmSettings">{{ $t("global.ok") }}</div>
          </div>
        </div>
        <!-- 遮罩层（从搜索栏下方开始） -->
        <div
          class="teacher-overlay"
          v-show="showAllTeacher || showSettings"
          @click="
            showAllTeacher = false;
            showSettings = false;
          "
        />
      </div>
    </van-sticky>
    <!-- 搜索历史 -->
    <div class="search-history" v-if="showHistory && noticeHistory.length > 0">
      <div class="history-header">
        <span class="history-title">{{ $t("notice.Search_History") }}</span>
        <!-- <van-icon name="delete-o" class="history-clear" /> -->
      </div>
      <div class="history-list" v-if="noticeHistory.length > 0">
        <div v-for="(item, index) in noticeHistory" :key="index" class="history-item" @click="clickHistory(item.keyword)">
          <span class="history-text">{{ item.keyword }}</span>
          <van-icon name="cross" class="history-delete" @click.stop="removeHistory(item._id, index)" />
        </div>
      </div>
    </div>
    <div v-else-if="showHistory && noticeHistory.length == 0">
      <div class="text-center p16 color9 font14">{{ $t("notice.No_history") }}</div>
    </div>
    <div v-show="!showHistory">
      <!-- 学年筛选 -->
      <div class="year-filter" @click="showYearPicker = true" v-if="!searchLoading">
        <span>{{ currentYear }}</span>
        <van-icon name="arrow-down" class="ml-5" />
      </div>
      <!-- 搜索结果列表 -->
      <div class="result-list">
        <van-loading size="24" class="text-center mt-20 pt-20" v-if="searchLoading" />
        <div v-if="journalData.length > 0">
          <!-- <van-list v-model="searchListLoading" :finished="searchFinished" finished-text="" @load="searchOnLoad" :immediate-check="false"> -->
          <div v-for="(item, i) in journalData" :key="item.id + '_' + i" class="result-card">
            <div class="card-link" @click="clickJournal(item)">
              <!-- 类型标签 + 时间 -->
              <div class="card-header">
                <van-tag v-if="item.type == 'notice' || (item.type == 'comment' && item.parent_type == 'notice')" class="tag-notice" color="#E7F4FF" text-color="#4D88D2">
                  {{ $t("notice.notice") }}
                </van-tag>
                <van-tag v-else-if="item.type == 'journal' || (item.type == 'comment' && item.parent_type == 'journal')" class="tag-dm" color="#FFFBE8" text-color="#F5A429">
                  {{ item.sub_type == 2 ? $t("journal.direct_message") : $t("journal.normal_journal") }}
                </van-tag>
                <van-tag v-else-if="item.type == 'contact' && item.sub_type == 3" class="tag-dm" color="#FFFBE8" text-color="#F5A429">{{ $t("contact.teachers") }}</van-tag>
                <van-tag v-else-if="item.type == 'contact' && item.sub_type == 4" class="tag-dm" color="#FFFBE8" text-color="#F5A429">{{ $t("contact.teams") }}</van-tag>
                <div v-if="settingsForm.showScore && search != ''" :class="item.score > 10 ? 'low-relevance' : 'card-score'">{{ $t("notice.relevance") }}{{ Number(item.score).toFixed(2) }}</div>
              </div>
              <!-- 标题 -->
              <div class="card-title">{{ item.title }}</div>
              <span class="time">{{ item.publish_at_ago }}</span>
              <!-- 发布人 -->
              <div class="card-author" v-if="item.publisher && !hidePublisher(item)">
                <van-image round width="32px" height="32px" :src="item.publisher.photoUrl" class="avatar mr-10" />
                <div class="publisher-name">{{ item.publisher.name }}</div>
                <div class="publisher-title">{{ item.publisher.hrPosition }}</div>
              </div>
              <!-- 摘要 -->
              <div class="summary-wrapper" v-if="item.highlights.length > 0" :data-item-id="item.id">
                <span class="icon iconfont iconfont-yinhao quote-icon"></span>
                <div class="card-summary" @click.stop="toggleExpand(item)" :class="{ collapsed: !expandedItems.has(item.id) }">
                  <span v-for="(highlight, index) in item.highlights" :key="index" v-html="'...... ' + highlight + (index === item.highlights.length - 1 ? '......' : '')"></span>
                  <div class="fade-overlay" v-if="overflowItems.has(item.id) && !expandedItems.has(item.id)"></div>
                </div>
                <!--  :class="{ 'fade-away': getTotalHighlightLength(item.highlights) > 20, 'fade-away-end': index === item.highlights.length - 1 && getTotalHighlightLength(item.highlights) > 20 }" -->
              </div>
            </div>
          </div>
          <!-- </van-list> -->
        </div>
        <van-empty :description="$t('global.empty')" v-else-if="!searchLoading" />
      </div>
    </div>
    <!-- 学年选择弹窗 -->
    <van-popup v-model="showYearPicker" round position="bottom">
      <van-picker show-toolbar :columns="yearColumns" text-key="title" value-key="title" @cancel="showYearPicker = false" @confirm="onYearConfirm" />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Sticky, Empty, List, Loading, Search, Tag, Picker, Popup, Image as VanImage } from "vant";
import { search, searchResult, searchHistory } from "@/api/searchNotice";
import logger from "@/plugins/logger";

Vue.use(Icon);
Vue.use(Empty);
Vue.use(Sticky);
Vue.use(List);
Vue.use(Search);
Vue.use(Tag);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(VanImage);
export default {
  name: "SearchCommon",
  components: {
    "van-loading": Loading,
  },
  data() {
    return {
      journalData: [],
      rawJournalData: [],
      search: "",
      showAllTeacher: false,
      teacherList: [],
      teacherid: "",
      teacherphotoUrl: "",
      teacherSearch: "",
      teacherListHeight: 0,
      searchFinished: false,
      searchPages: { page: 1, total: 0, page_size: 10 },
      noticeHistory: [],
      searchLoading: false,
      searchListLoading: false,
      showYearPicker: false,
      currentYear: "",
      yearColumns: [],
      showHistory: true,
      searchInit: false,
      expandedItems: new Set(),
      overflowItems: new Set(),
      resetting: false,
      showSettings: false,
      settingsForm: {
        includesNotice: true,
        includesJournal: true,
        includesComment: false,
        showLowRelevance: false,
        showScore: true,
      },
      defaultSettings: {
        includesNotice: true,
        includesJournal: true,
        includesComment: false,
        showLowRelevance: false,
        showScore: true,
      },
      pendingSettings: {
        includesNotice: true,
        includesJournal: true,
        includesComment: false,
        showLowRelevance: false,
        showScore: true,
      },
    };
  },
  computed: {
    filteredTeacherList() {
      const keyword = this.teacherSearch.trim().toLowerCase();
      if (!keyword) return this.teacherList;
      return this.teacherList.filter((item) => (item.name || "").toLowerCase().includes(keyword));
    },
  },
  created() {
    this.loadSettings();
  },
  // activated() {
  //   this.resetting = true;
  //   this.showHistory = false;
  //   this.search = "";
  //   this.teacherData();
  //   this.journalData = [];
  //   this.expandedItems = new Set();
  //   this.overflowItems = new Set();
  //   this.$nextTick(() => {
  //     this.resetting = false;
  //   });
  // },
  watch: {
    "$route.query.uid": {
      handler(newUid, oldUid) {
        this.search = "";
        if (newUid !== oldUid || (newUid === undefined && oldUid === undefined)) {
          this.expandedItems = new Set();
          this.overflowItems = new Set();
          this.teacherData();
        }
      },
      immediate: true,
    },
    search(newVal) {
      if (this.resetting) return;
      if (newVal === "" && !this.teacherid) {
        this.showHistory = true;
        this.journalData = [];
        this.rawJournalData = [];
        return;
      }
      this.showHistory = false;
      if (newVal !== "") {
        this.searchLoading = true;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchPages.page = 1;
        this.searchTextData("init");
      }, 1000);
    },
    showAllTeacher(val) {
      if (!val) return;
      this.$nextTick(() => {
        this.calcTeacherListHeight();
        if (this.teacherid) {
          const active = this.$el.querySelector(".teacherActive");
          if (active) active.scrollIntoView({ block: "center" });
        }
      });
    },
    teacherSearch() {
      this.$nextTick(() => {
        const el = this.$refs.teacherList;
        if (el) el.scrollTop = 0;
        this.calcTeacherListHeight();
      });
    },
  },
  methods: {
    teacherData() {
      this.search = "";
      search({}).then((res) => {
        this.noticeHistory = res.data.history;
        this.teacherList = res.data.publishers;
        this.teacherSearch = "";
        this.searchInit = true;
        this.$nextTick(() => this.calcTeacherListHeight());
        if (this.$route.query.uid) {
          this.teacherList.forEach((item) => {
            if (item.uid == this.$route.query.uid) {
              this.selectTeacher(item);
            }
          });
        } else {
          this.clearTeacher();
        }
      });
    },
    calcTeacherListHeight() {
      const el = this.$refs.teacherList;
      if (!el) return;
      const items = el.querySelectorAll(".teacher-item");
      if (!items.length) {
        this.teacherListHeight = 0;
        return;
      }
      // 取全部已渲染老师项的平均高度，按"显示 8.5 个"计算列表高度
      let total = 0;
      items.forEach((item) => (total += item.offsetHeight));
      const itemHeight = total / items.length;
      if (!itemHeight) return;
      // 不超过可视区域，避免超出屏幕
      const maxLimit = window.innerHeight - 160;
      this.teacherListHeight = Math.min(Math.round(itemHeight * 7.5), maxLimit);
    },
    removeHistory(id, index) {
      searchHistory(id).then(() => {
        this.noticeHistory.splice(index, 1);
      });
    },
    clickHistory(keyword) {
      this.search = keyword;
    },
    clearSearch() {
      this.search = "";
    },
    onSearch() {
      this.showHistory = false;
      this.searchPages.page = 1;
      this.searchTextData("init");
    },
    showTeacher() {
      this.showAllTeacher = !this.showAllTeacher;
      this.showSettings = false;
      if (this.showAllTeacher) {
        this.teacherSearch = "";
        logger.send({ category: "search", op: "open_publisher_btn" });
      }
    },
    settings() {
      if (this.showSettings) {
        logger.send({ category: "search", op: "open_settings_btn" });
      }
      this.showSettings = !this.showSettings;
      this.showAllTeacher = false;
      if (this.showSettings) {
        this.pendingSettings = { ...this.settingsForm };
      }
    },
    toggleType(key) {
      const types = ["includesNotice", "includesJournal", "includesComment"];
      const activeCount = types.filter((t) => this.pendingSettings[t]).length;
      if (this.pendingSettings[key] && activeCount <= 1) return;
      this.pendingSettings[key] = !this.pendingSettings[key];
    },
    loadSettings() {
      const saved = localStorage.getItem("searchCommonSettings");
      if (saved) {
        const parsed = JSON.parse(saved);
        this.settingsForm = { ...this.defaultSettings, ...parsed };
      }
    },
    resetSettings() {
      this.pendingSettings = { ...this.defaultSettings };
      this.settingsForm = { ...this.pendingSettings };
      localStorage.setItem("searchCommonSettings", JSON.stringify(this.settingsForm));
      this.showSettings = false;
      if (this.search != "" || this.teacherid != "") {
        this.searchTextData("init");
      }
    },
    initSetting() {
      const typeChanged = this.pendingSettings.includesNotice !== this.settingsForm.includesNotice || this.pendingSettings.includesJournal !== this.settingsForm.includesJournal || this.pendingSettings.includesComment !== this.settingsForm.includesComment;
      this.settingsForm = { ...this.pendingSettings };
      localStorage.setItem("searchCommonSettings", JSON.stringify(this.settingsForm));
      this.showSettings = false;
      if (this.search != "" || this.teacherid != "") {
        if (typeChanged) {
          this.searchTextData("init");
        } else {
          this.filterData();
        }
      }
    },
    confirmSettings() {
      logger.send({ category: "search", op: "settings_ok_btn" });
      this.initSetting();
    },
    clearTeacher() {
      this.teacherid = "";
      this.teacherphotoUrl = "";
      this.showAllTeacher = false;
      this.showHistory = false;
      this.searchPages.page = 1;
      if (this.search != "") {
        this.searchTextData("init");
      } else {
        this.showHistory = true;
      }
    },
    selectTeacher(item) {
      if (item.uid == this.teacherid) {
        this.clearTeacher();
        return;
      }
      this.teacherid = item.uid;
      this.teacherphotoUrl = item.photoUrl || "";
      this.showAllTeacher = false;
      this.showHistory = false;
      this.searchPages.page = 1;
      this.searchTextData("init");
    },
    onYearConfirm(value) {
      this.currentYear = value.title;
      this.showYearPicker = false;
      this.searchPages.page = 1;
      this.searchTextData("init");
    },
    filterData() {
      this.journalData = this.rawJournalData.filter((item) => {
        const isNotice = item.type === "notice" || (item.type === "comment" && item.parent_type === "notice");
        const isJournal = item.type === "journal" || (item.type === "comment" && item.parent_type === "journal");
        const isContact = item.type === "contact";
        if (isNotice && !this.settingsForm.includesNotice) return false;
        if (isJournal && !this.settingsForm.includesJournal) return false;
        if (isContact && !this.settingsForm.includesComment) return false;
        if (!this.settingsForm.showLowRelevance && item.score !== undefined && item.score < 10) return false;
        return true;
      });
    },
    searchTextData(type) {
      if (type) {
        this.searchPages.page = 1;
        this.journalData = [];
        this.rawJournalData = [];
        document.documentElement.scrollTop = 0;
      }
      this.searchLoading = true;
      this.searchFinished = false;
      const match = this.yearColumns.find((y) => y.title === this.currentYear);
      const typeArr = [];
      if (this.settingsForm.includesNotice) typeArr.push(1);
      if (this.settingsForm.includesJournal) typeArr.push(2);
      if (this.settingsForm.includesComment) typeArr.push(3);
      const params = {
        page: this.searchPages.page,
        publisher_id: this.teacherid,
        keyword: this.search,
        start_year: match ? match.start_year : "",
        type: typeArr.join(","),
        // page_size: this.searchPages.page_size,
      };
      if (this.search == "" && this.teacherid == "") {
        return;
      }
      searchResult(params)
        .then((res) => {
          this.yearColumns = res.data.years || [];
          if (this.currentYear == "") {
            this.currentYear = this.yearColumns[0].title || "";
          }
          if (type) {
            this.rawJournalData = res.data.items || [];
          } else {
            this.rawJournalData.push(...(res.data.items || []));
          }
          this.filterData();
          this.searchLoading = false;
          // if (res.data.total !== undefined) {
          //   this.searchPages = {
          //     page: parseInt(res.data.page) || 1,
          //     total: parseInt(res.data.total) || 0,
          //     page_size: parseInt(res.data.page_size) || 10,
          //   };
          // }
          this.searchListLoading = false;
          this.$nextTick(() => {
            // this.applyFadeEffect();
            this.checkAllOverflows();
          });
        })
        .catch(() => {
          this.searchLoading = false;
          this.searchListLoading = false;
        });
    },
    toggleExpand(item) {
      const newSet = new Set(this.expandedItems);
      if (newSet.has(item.id)) {
        newSet.delete(item.id);
      } else {
        newSet.add(item.id);
      }
      this.expandedItems = newSet;
      this.$nextTick(() => {
        // this.applyFadeEffect();
        this.checkAllOverflows();
      });
    },
    checkAllOverflows() {
      const summaries = this.$el.querySelectorAll(".card-summary");
      const toRemove = [];
      const newOverflow = new Set();

      summaries.forEach((el) => {
        const wrapper = el.closest(".summary-wrapper");
        if (!wrapper) return;
        const itemId = wrapper.getAttribute("data-item-id");
        if (!itemId) return;

        // 创建隐藏克隆元素测量完整高度
        const clone = el.cloneNode(true);
        const rect = el.getBoundingClientRect();
        clone.style.position = "absolute";
        clone.style.visibility = "hidden";
        clone.style.height = "auto";
        clone.style.overflow = "visible";
        clone.style.width = rect.width + "px";
        clone.classList.remove("collapsed");
        document.body.appendChild(clone);

        const lineHeight = 20;
        const maxHeight = lineHeight * 4;
        const isOverflowing = clone.scrollHeight > maxHeight + 10;
        document.body.removeChild(clone);

        if (isOverflowing) {
          newOverflow.add(itemId);
        } else if (this.expandedItems.has(itemId)) {
          toRemove.push(itemId);
        }
      });

      // 更新 overflowItems
      this.overflowItems = newOverflow;

      // 批量从 expandedItems 中移除
      if (toRemove.length > 0) {
        const newSet = new Set(this.expandedItems);
        toRemove.forEach((id) => newSet.delete(id));
        this.expandedItems = newSet;
      }
    },
    // getTotalHighlightLength(highlights) {
    //   return highlights.reduce((sum, h) => sum + h.length, 0);
    // },
    // applyFadeEffect() {
    //   this.$el.querySelectorAll(".fade-away").forEach((el) => {
    //     const isEnd = el.classList.contains("fade-away-end");
    //     const chars = el.textContent.split("");
    //     const nonSpaceCount = chars.filter((c) => c !== " ").length;
    //     const fadeCount = Math.min(8, nonSpaceCount);
    //     const endFadeCount = Math.min(10, nonSpaceCount);
    //     const fadeStart = nonSpaceCount - endFadeCount;
    //     let letterIndex = 0;
    //     let fadeIndexStart = 0;
    //     let fadeIndexEnd = 0;
    //     el.innerHTML = chars
    //       .map((char) => {
    //         if (char === " ") return " ";
    //         // 前 8 个字符：从模糊到清晰
    //         if (letterIndex < fadeCount) {
    //           const span = `<span style="--i:${fadeIndexStart++}; --total:${fadeCount};">${char}</span>`;
    //           letterIndex++;
    //           return span;
    //         }
    //         // 后 10 个字符：从清晰到模糊
    //         if (isEnd && letterIndex >= fadeStart) {
    //           const span = `<span class="end-blur" style="--i:${fadeIndexEnd++}; --total:${endFadeCount};">${char}</span>`;
    //           letterIndex++;
    //           return span;
    //         }
    //         letterIndex++;
    //         return `<span>${char}</span>`;
    //       })
    //       .join("");
    //   });
    // },
    searchOnLoad() {
      // const totalPages = Math.ceil(this.searchPages.total / this.searchPages.page_size);
      // if (this.searchPages.page < totalPages) {
      //   this.searchPages.page += 1;
      //   this.searchTextData();
      // } else {
      //   this.searchFinished = true;
      // }
    },
    hidePublisher(item) {
      return item.type == "contact" && item.sub_type == 4;
    },
    clickJournal(item) {
      const routes = {
        journal: () => `/journal/${item.id}`,
        notice: () => `/notice/${item.id}`,
      };
      if (routes[item.type]) {
        this.$router.push({ path: routes[item.type]() });
        return;
      }
      if (item.type == "comment") {
        this.$router.push({ path: `/${item.parent_type}/${item.id}?commentId=${item.sub_id}` });
        return;
      }
      if (item.type == "contact" && (item.sub_type == 3 || item.sub_type == 4)) {
        this.$router.push({ path: `/message/${item.contact_id}/${item.sub_type}/${item.child_id}?commentId=${item.sub_id}` });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-wrapper {
  position: relative;
  z-index: 2001;
  background: #fff;

  .teacher-dropdown {
    position: absolute;
    top: 98%;
    left: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    border-radius: 0 0 16px 16px;
    padding: 0 16px 16px;
    overflow: hidden;

    .van-search {
      padding: 0 0 8px;
    }

    .teacher-list {
      max-height: 50vh;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;

      .teacher-item {
        display: flex;
        align-items: center;
        border: 1px solid transparent;
        padding: 8px;
        .teacher-avatar {
          width: 44px;
          height: 44px;
          flex-shrink: 0;
          margin-right: 12px;
        }

        .teacher-info {
          flex: 1;
          .teacher-name {
            font-size: 15px;
            color: #323233;
            line-height: 22px;
          }

          .teacher-position {
            font-size: 13px;
            color: #969799;
            margin-top: 2px;
          }
        }
      }
      .teacherActive {
        border: 1px solid rgba(25, 137, 250, 0.8);
        border-radius: 8px;
        background: rgba(25, 137, 250, 0.1);
      }
    }
  }

  .settings-panel {
    position: absolute;
    top: 98%;
    left: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    border-radius: 0 0 16px 16px;
    padding: 16px;

    .settings-section {
      margin-bottom: 20px;

      .settings-label {
        font-size: 12px;
        color: #323233;
        font-weight: 500;
        margin-bottom: 12px;
      }

      .settings-options {
        display: flex;
        gap: 12px;
        .option-null {
          flex: 1;
        }
        .option-btn {
          flex: 1;
          text-align: center;
          padding: 6px 0;
          font-size: 14px;
          color: #646566;
          background: #f5f6f7;
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.2s;

          &.active {
            color: #1989fa;
            background: #e8f3ff;
          }
        }
      }
    }

    .settings-actions {
      display: flex;
      gap: 12px;
      margin-top: 8px;

      .btn-reset {
        flex: 1;
        text-align: center;
        padding: 12px 0;
        font-size: 15px;
        color: #646566;
        background: #fff;
        border: 1px solid #ebedf0;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s;

        &:active {
          background: #f5f6f7;
        }
      }

      .btn-confirm {
        flex: 1;
        text-align: center;
        padding: 12px 0;
        font-size: 15px;
        color: #fff;
        background: #1989fa;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s;

        &:active {
          background: #1677d8;
        }
      }
    }
  }
}

.search-bar {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;

  .publisher-select {
    display: flex;
    align-items: center;
    padding-right: 10px;
    margin-right: 10px;
    font-size: 14px;
    color: #323233;
    white-space: nowrap;

    .avatar-select {
      width: 24px;
      height: 24px;
    }
  }

  .van-search {
    padding: 0;
    flex: 1;
  }
}

.year-filter {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  font-size: 14px;
  color: #323233;
}

.search-history {
  background: #fff;
  margin: 12px;
  padding: 12px;
  border-radius: 12px;

  .history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .history-title {
      font-size: 14px;
      color: #323233;
    }

    .history-clear {
      font-size: 16px;
      color: #646566;
    }
  }

  .history-list {
    .history-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #f5f5f5;
      font-size: 14px;
      color: #323233;

      .history-text {
        flex: 1;
        color: #646566;
      }

      .history-delete {
        font-size: 12px;
        color: #c8c9cc;
        padding: 4px;
      }
    }
  }
}

.result-list {
  background: #f7f8fa;
  min-height: calc(100vh - 120px);
  padding: 0 12px;

  .result-card {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 16px;

    .card-link {
      display: block;
      color: inherit;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebedf0;
      .tag-notice,
      .tag-dm {
        padding: 2px 8px;
        font-size: 12px;
      }
    }

    .card-title {
      font-size: 16px;
      font-weight: bold;
      color: #323233;
      line-height: 22px;
      margin-top: 10px;
    }
    .time {
      font-size: 12px;
      color: #969799;
    }
    .low-relevance {
      color: #07c160;
      font-size: 12px;
    }
    .card-score {
      font-size: 12px;
      color: #969799;
    }
    .card-author {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .avatar {
        flex-shrink: 0;
      }

      .publisher-name {
        font-size: 14px;
        color: #323233;
        font-weight: 500;
        padding-right: 8px;
      }

      .publisher-title {
        height: 12px;
        line-height: 12px;
        font-size: 12px;
        color: #969799;
        padding-left: 8px;
        border-left: 1px solid #969799;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
      }
    }

    .summary-wrapper {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
      background: #f0f7ff;
      border: 1px solid rgba(25, 137, 250, 0.08);
      border-radius: 6px;
      padding: 10px 12px;
      .summary-toggle {
        flex-shrink: 0;
        font-size: 13px;
        color: #1989fa;
        padding-right: 8px;
        cursor: pointer;
        line-height: 20px;
        user-select: none;
      }
    }
    .quote-icon {
      font-size: 14px;
      color: #1989fa;
      font-weight: bold;
      line-height: 20px;
      margin-right: 6px;
    }
    .card-summary {
      font-size: 13px;
      color: #646566;
      line-height: 20px;
      flex: 1;
      overflow: hidden;
      position: relative;

      .fade-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 40px;
        background: linear-gradient(to bottom, rgba(240, 247, 255, 0), rgba(240, 247, 255, 1));
        pointer-events: none;
      }

      &.collapsed {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
  }
}

.teacher-overlay {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: calc(100vh - 100%);
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
</style>
<style>
.fade-away span {
  opacity: calc(var(--i) / var(--total) * 0.75 + 0.25);
  filter: blur(calc((var(--total) - var(--i)) / var(--total) * 2px));
  transition: opacity 0.3s, filter 0.3s;
}
.fade-away span.end-blur {
  opacity: calc(1 - var(--i) / var(--total) * 0.75);
  filter: blur(calc(var(--i) / var(--total) * 2px));
}
</style>
